import baseAPI from "@/http";

const router = "api/municipios-solucoes-tipo-solucao";

export const municipiosSolucoesTipoSolucaoAPI = {
  list: () => baseAPI.get(router),
};
